import { createSlice } from '@reduxjs/toolkit';
import { loadSuggestionsFromStorage} from '../storageUtils.js';

const persistedSuggestions = loadSuggestionsFromStorage();

function isVotingPastDeadline(votingDeadline){
    const now = new Date();
    const deadlineDate = new Date(votingDeadline);
    return now > deadlineDate;
}


const suggestionSlice = createSlice({
    name: "suggestions",
    initialState:  { //exempelstruktur
        clubId: persistedSuggestions?.clubId ||"",
        votingDeadline: persistedSuggestions?.votingDeadline || "",//"2025-12-24",
        isVotingActive: persistedSuggestions?.isVotingActive || false,
        suggestedBooks: persistedSuggestions?.suggestedBooks || [/*[ 
           {
            bookId: "13420693",
            title: "Biografmysteriet (LasseMajas detektivbyrå, #6)",
            genre: "Barn & ungdom",
            pages: 89,
            author: "Martin Widmark",
            description: "Lasse och Maja är tillbaka i Valleby för att lösa ännu ett mysterium! Den här gången handlar det om en biograf som plötsligt börjar spöka. Vem är det som skrämmer bort besökarna, och varför? Följ med Lasse och Maja när de tar sig an fallet och avslöjar sanningen bakom biografmysteriet.",
            bookImg: "https://m.media-amazon.com/images/S/compressed.photo.goodreads.com/books/1327236919i/13420693.jpg",
            totalScore: 10,
            voters: [
                {userId: 3, score: 5},
                {userId: 2, score: 5},
                ],
            },
            {
            bookId: "12134589",
            title: "Diamantmysteriet (LasseMajas detektivbyrå, #1)",
            genre: "Barn & ungdom",
            pages: 80,
            author: "Martin Widmark",
            description: "Lasse och Maja är två unga detektiver som bor i den lilla staden Valleby. När en värdefull diamant försvinner från stadens museum, tar de på sig uppdraget att lösa mysteriet. Med hjälp av sina skarpa sinnen och modiga hjärtan, ger de sig ut på en spännande jakt efter den försvunna diamanten. Kommer Lasse och Maja att lyckas hitta diamanten och avslöja tjuven innan det är för sent?",
            bookImg: "https://m.media-amazon.com/images/S/compressed.photo.goodreads.com/books/1311582023i/12134589.jpg",
            totalScore: 11,
            voters: [
                {userId: 3, score: 3},
                {userId: 2, score: 3},
                {userId: 2, score: 5},
                ],
            },
            {
            bookId: "12958489",
            title: "Zoomysteriet (LasseMajas detektivbyrå, #12)",
            genre: "Barn & ungdom",
            pages: 96,
            author: "Martin Widmark",
            description:"Unusual book",
            bookImg: "https://m.media-amazon.com/images/S/compressed.photo.goodreads.com/books/1319566286i/12958489.jpg",
            totalScore: 5,
            voters: [
                {userId: 3, score: 3},
                {userId: 2, score: 2},
                ],
            },
            // fler bokobjekt */
    
        ]
    },

    /* //objekt med klubId som key och 
    clubId: { [ 
                {bookId: ,
                 title: "...",
                 pages: 123,
                 author: "...",
                 totalScore: 3 ,
                 voters: { 
                          {memberId: 5, score: 2},
                          {memberId: 2, score: 1},
                        }
                }, {nästa bokobjekt}
    ]
    */ 
    
    reducers: {
        fetchFromFirestore(state, action){
            //hämtar data från firestore och sätter i state
            state.clubId = action.payload.clubId;
            state.votingDeadline = action.payload.votingDeadline;
            state.isVotingActive = action.payload.isVotingActive;
            state.suggestedBooks = action.payload.suggestedBooks;
        },
        addBookSuggestion(state, action){
            //vi behöver veta vilken bok som ska läggas till
            state.suggestedBooks.push({
                bookId: action.payload.bookId,
                title: action.payload.title,
                genre: action.payload.genre,
                pages: action.payload.pages,
                author: action.payload.author,
                description: action.payload.description,
                bookImg: action.payload.bookImg,
                totalScore: 0,
                voters: []
            })
        },
        vote(state, action){
            //vi behöver veta vilken bokid och vilken score och vllken user             
            //hitta boken i state
            const book = state.suggestedBooks.find(book => book.bookId === action.payload.bookId);
            const existingVote = book.voters.find(vote => vote.userId === action.payload.userId);
            if (existingVote) {
                // Om användaren redan har röstat, uppdatera deras poäng
                existingVote.score = action.payload.score;
            } else {
                // Annars, lägg till en ny röst
                book.voters.push({ userId: action.payload.userId, score: action.payload.score });
            }
            //uppdatera totalScore
            book.totalScore = book.voters.reduce((total, voter) => total + voter.score, 0);
        },
        setVotingDeadline(state, action){
            state.votingDeadline = action.payload.votingDeadline || "";
            state.isVotingActive = action.payload.isVotingActive || false;
        },
        updateSuggestionInfo(state, action){
            //tar in klubben och sen 
            state.clubId = action.payload.clubId;
            const deadline = action.payload.votingDeadline || "";
            state.votingDeadline = deadline;
            // Derive activity: prefer explicit flag from Firestore, else infer from deadline
            const hasExplicitFlag = typeof action.payload.isVotingActive === "boolean";
            const hasDeadline = Boolean(deadline);
            const inferredActive = hasDeadline && !isVotingPastDeadline(deadline); // Active if deadline exists and is in the future
            state.isVotingActive = hasExplicitFlag ? action.payload.isVotingActive : inferredActive;
        },
        updateSuggestionBooks(state, action){
            state.suggestedBooks = action.payload.suggestedBooks || [];
        },
    }
})
export const {addBookSuggestion, vote, setVotingDeadline, updateSuggestionInfo, updateSuggestionBooks, endVotingPeriod} = suggestionSlice.actions;
export default suggestionSlice.reducer;